<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-globe-europe"></i>
        {{ $t('CHANNEL_SETTINGS_LANGUAGE_SETTINGS_TITLE') }}:
      </h5>
    </div>

    <div class="card-body">
      <div class="custom-control custom-radio">
        <input type="radio" id="lang_en" name="customRadio" class="custom-control-input" value="en"
               v-model="settings.languageCode">
        <label class="custom-control-label" for="lang_en">{{ $t('LANG_EN') }}</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="lang_de" name="customRadio" class="custom-control-input" value="de"
               v-model="settings.languageCode">
        <label class="custom-control-label" for="lang_de">{{ $t('LANG_DE') }}</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="lang_fr" name="customRadio" class="custom-control-input" value="fr"
               v-model="settings.languageCode">
        <label class="custom-control-label" for="lang_fr">{{ $t('LANG_FR') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultLanguageSettings',
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>

<style scoped>

</style>
